module.exports = __webpack_public_path__ + "static/media/Stellar Max Single Headboard - 120 cm_Charcoal.ff6706ae.png";